import { RouteConfig } from 'vue-router';
import { PermissionLevel } from '@/utils/permission';

const LazyLayout = () => import('@/layout/index.vue');

export default [
  {
    children: [
      {
        component: () => import('@/pages/admin/security/roles/index.vue'),
        meta: {
          permissions: [{ Role: PermissionLevel.Read }],
          title: 'menu_admin_roles'
        },
        name: 'Roles',
        path: 'roles'
      },
      {
        component: () => import('@/pages/admin/security/roles/create.vue'),
        hidden: true,
        meta: {
          icon: 'edit',
          permissions: [{ Role: PermissionLevel.Write }],
          title: 'createRole'
        },
        name: 'CreateRole',
        path: 'roles/create'
      },
      {
        component: () => import('@/pages/admin/security/roles/edit.vue'),
        hidden: true,
        meta: {
          noCache: true,
          permissions: [{ Role: PermissionLevel.Read }],
          title: 'editRole'
        },
        name: 'EditRole',
        path: 'roles/edit/:id(\\d+)'
      },
      {
        component: () => import('@/pages/admin/security/users/index.vue'),
        meta: {
          permissions: [{ User: PermissionLevel.Read }],
          title: 'menu_admin_users'
        },
        name: 'Users',
        path: 'users'
      },
      {
        component: () => import('@/pages/admin/security/users/create.vue'),
        hidden: true,
        meta: {
          icon: 'edit',
          permissions: [{ User: PermissionLevel.Write }],
          title: 'createUser'
        },
        name: 'CreateUser',
        path: 'users/create'
      },
      {
        component: () => import('@/pages/admin/security/users/edit.vue'),
        hidden: true,
        meta: {
          noCache: true,
          permissions: [{ User: PermissionLevel.Read }],
          title: 'editUser'
        },
        name: 'EditUser',
        path: 'users/edit/:id(\\d+)'
      },
      {
        component: () => import('@/pages/admin/application/configuration/index.vue'),
        meta: {
          permissions: [{ Configuration: PermissionLevel.Read }],
          title: 'menu_admin_configuration'
        },
        name: 'Configuration',
        path: 'configuration'
      },
      {
        component: () => import('@/pages/admin/application/configuration/edit.vue'),
        hidden: true,
        meta: {
          noCache: true,
          permissions: [{ Configuration: PermissionLevel.Read }],
          title: 'editConfiguration'
        },
        name: 'EditConfiguration',
        path: 'configuration/edit/:id'
      },
      {
        component: () => import('@/pages/admin/maintenance/accesslog/index.vue'),
        meta: {
          permissions: [{ AccessLog: PermissionLevel.Read }],
          title: 'menu_admin_accesslog'
        },
        name: 'Access log',
        path: 'accesslog'
      },
      {
        component: () => import('@/pages/admin/maintenance/eventlog/index.vue'),
        meta: {
          permissions: [{ EventLog: PermissionLevel.Read }],
          title: 'menu_admin_eventlog'
        },
        name: 'Event Log',
        path: 'eventlog'
      }
    ],
    component: LazyLayout,
    meta: { icon: 'settings', title: 'menu_admin' },
    name: 'Management',
    path: '/management'
  } as RouteConfig,
  {
    children: [
      {
        component: () => import('@/pages/admin/mapping/producttypemapping/index.vue'),
        meta: {
          permissions: [{ Country: PermissionLevel.Read }],
          title: 'menu_admin_producttypemapping'
        },
        name: 'ProductTypeMapping',
        path: 'productTypemapping'
      },
      // PLOP: Application routes
      {
        component: () => import('@/pages/admin/mapping/defaultbottomfinishmapping/index.vue'),
        meta: {
          permissions: [{ Country: PermissionLevel.Read }],
          title: 'menu_admin_defaultbottomfinishmapping'
        },
        name: 'DefaultBottomFinishMapping',
        path: 'defaultBottomfinishmapping'
      }
    ],
    component: LazyLayout,
    meta: { icon: 'mapping', title: 'menu_admin_mapping' },
    name: 'Mapping',
    path: '/mapping'
  } as RouteConfig,
  {
    children: [
      {
        component: () => import('@/pages/user/settings.vue'),
        meta: { noCache: true, title: 'userSettings' },
        name: 'Settings',
        path: 'settings'
      }
    ],
    component: LazyLayout,
    hidden: true,
    path: '/user',
    redirect: 'settings'
  } as RouteConfig
];
